import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getContents } from '../store/slices/contentSlice';

function ContentList() {
  const dispatch = useDispatch();
  const { contents, pagination, isLoading } = useSelector((state) => state.content);
  
  useEffect(() => {
    dispatch(getContents());
  }, [dispatch]);

  // Polling for real-time content updates
  useEffect(() => {
    const pollContent = setInterval(() => {
      dispatch(getContents());
    }, 15000); // 15 seconds

    return () => {
      clearInterval(pollContent);
    };
  }, [dispatch]);
  
  return (
    <div className="content-list">
      <h1>Content</h1>
      <Link to="/content/new" className="btn-create">Create New Content</Link>
      
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div className="content-grid">
          {contents.map((content) => (
            <div key={content._id} className="content-card">
              <h3>{content.title}</h3>
              <p>{content.description}</p>
              <div className="content-meta">
                <span className={`status ${content.status}`}>{content.status}</span>
                <span>{content.type}</span>
              </div>
              <Link to={`/content/${content._id}`}>Edit</Link>
            </div>
          ))}
        </div>
      )}
      
      {pagination.pages > 1 && (
        <div className="pagination">
          {Array.from({ length: pagination.pages }, (_, i) => (
            <button key={i + 1} onClick={() => dispatch(getContents({ page: i + 1 }))}>
              {i + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ContentList;